
(function () {
    'use strict';

    angular
        .module('controlModule')
        .directive('grcTestResult', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {
        var directiveScope = _.clone(boxTmplScope);
        directiveScope.readOnly = '@';
        directiveScope.loadingStatus = '=?';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$scope', '$controller', function ($scope, $controller) {
                // Box Template
                $scope.baseTemplatePath = '/app/shared/grc/control/grcTestResult.[Template].tpl.html';
                // Permissions default values
                $scope.boxFeatureRole = $scope.boxFeatureRole || 'ControlGrpBusinessUnit_GovernanceManagement';
                $scope.boxPermissionKey = $scope.boxPermissionKey || 'TestResult';

                $controller('BoxTmplController', { $scope: $scope });

                $scope.$watch('readOnly', function() {
                    if (typeof $scope.readOnly === 'string') {
                        $scope.readOnly = $scope.readOnly === 'true';
                    }
                    $scope.readOnly = $scope.readOnly || !$scope.boxPermissions.Edit;
                });
            }],
            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();